import { IconSpeed } from "../../../../../components/buttons/IconButtons"
import {SPEED_UNIT_MODEL} from "../../Manage/Model/Model";
import {useTranslation} from "react-i18next";
import {getValueByKey} from "../../../../../Apis/functions";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * @description
 * React component that visually displays a speed indicator with an icon and text.
 * Commonly used in traffic-related modules to show a vehicle's speed in km/h.
 *
 *
 * @param {Object} props - React component props.
 * @param {number|string} props.speed - The speed value to be displayed (in km/h).
 * @param {string} [props.iconClass] - Optional CSS class applied to the speed icon for color or sizing.
 * @param {string} [props.textClass="fs-14px"] - Optional CSS class applied to the text displaying the speed.
 * @param {string} [props.className=""] - Optional wrapper container class for layout adjustments.
 *
 * @returns {JSX.Element} A styled component displaying a speed icon and its corresponding value in km/h.
 */

const SpeedIndicator = ({ speed, speedUnit, iconClass, textClass = "fs-14px", className = '' }) => {
    const  unit = getValueByKey(speedUnit, 'name', SPEED_UNIT_MODEL);
    const {t} = useTranslation();

    return (
        <div className={`d-flex flex-shrink-0 gap-2 align-items-center ${className}`}>
            <IconSpeed className={`w-h-20px ${iconClass}`} />
            <p className={`fs-14px ${textClass}`}>{speed} {t(unit)}</p>
        </div>
    )

}
export default SpeedIndicator
